import { useTranslation } from 'react-i18next';

const sections = [
  {
    title: 'privacy.overviewTitle',
    body: 'privacy.overviewBody',
  },
  {
    title: 'privacy.infoTitle',
    body: 'privacy.infoBody',
    bullets: [
      'privacy.bulletName',
      'privacy.bulletContact',
      'privacy.bulletUsage',
      'privacy.bulletSocial',
      'privacy.bulletDevice',
    ],
  },
  {
    title: 'privacy.useTitle',
    body: 'privacy.useBody',
    bullets: [
      'privacy.bulletProvide',
      'privacy.bulletImprove',
      'privacy.bulletTestimonials',
      'privacy.bulletAnalytics',
    ],
  },
  {
    title: 'privacy.shareTitle',
    body: 'privacy.shareBody',
    bullets: [
      'privacy.bulletHosting',
      'privacy.bulletLegal',
      'privacy.bulletBusiness',
    ],
  },
  {
    title: 'privacy.securityTitle',
    body: 'privacy.securityBody',
  },
  {
    title: 'privacy.retentionTitle',
    body: 'privacy.retentionBody',
  },
  {
    title: 'privacy.rightsTitle',
    body: 'privacy.rightsBody',
    bullets: [
      'privacy.bulletAccess',
      'privacy.bulletCorrect',
      'privacy.bulletDelete',
      'privacy.bulletObject',
      'privacy.bulletWithdraw',
    ],
  },
  {
    title: 'privacy.cookTitle',
    body: 'privacy.cookBody',
    bullets: ['privacy.bulletAnalytics'],
  },
  {
    title: 'privacy.childTitle',
    body: 'privacy.childBody',
  },
  {
    title: 'privacy.changeTitle',
    body: 'privacy.changeBody',
  },
  {
    title: 'privacy.contactTitle',
    body: 'privacy.contactBody',
  },
];

export function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="pt-24 pb-16 min-h-screen bg-gradient-to-b from-sky-50 via-white to-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sky-100 text-sky-700 text-sm font-semibold mb-4">
            🔒 {t('privacy.badge')}
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-black text-campaign-black mb-4">
            {t('privacy.title')}
          </h1>
          <p className="text-lg text-gray-500">
            {t('privacy.lastUpdated')}{' '}
            <time>{new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</time>
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 px-8 py-10 space-y-10">
          {sections.map((section, i) => (
            <div key={i} className={i > 0 ? 'pt-8 border-t border-gray-100' : ''}>
              <h2 className="text-xl font-heading font-bold text-campaign-black mb-3">
                {t(section.title)}
              </h2>
              <p className="text-gray-700 leading-relaxed text-sm">
                {t(section.body)}
              </p>
              {section.bullets && (
                <ul className="mt-4 space-y-2">
                  {section.bullets.map((key, j) => (
                    <li key={j} className="flex items-start gap-2 text-gray-700 text-sm">
                      <span className="inline-block w-1.5 h-1.5 rounded-full bg-sky-500 mt-2 flex-shrink-0" />
                      {t(key)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
